import React from "react";
import "../Contactus/Contactus.css";
import Talk from "./Talk";
import { MdAdsClick } from "react-icons/md";
import Place from "./Place";

const ContactUs = () => {
  
  const callAdmin = () => {
    window.location.href = 'tel:+919220347091'; // replace with real number
  };
  const handleEmailClick = () => {
    window.location.href = 'mailto:info@shreeverevents.com';
  };
  
  return (
    <>
      <div className="contact-us">
        <div className="full-co">
          <div className="contact-details">
           {/*-<h1>Contact Us</h1>-*/} 
            <p>
              Thank you for considering <strong className="ts">श्री Var Event & Conference</strong> for your next event. Whether you’re planning a wedding, a business conference, or a social gathering, our expert team is here to make your experience stress-free and extraordinary. Reach out to us—we’d love to hear your vision!
            </p>
            <div className="help-section">
              <h2>Do You Need Assistance?</h2>
              <p className="call-us">
                <strong>Call Us On</strong>
                <span className="contact-number" onClick={callAdmin}> +91 922-034-7091 <MdAdsClick className="ca-icon"/></span>
              </p>
              <p>
                <a href="mailto:info@shreeverevents.com" className="contact-email">
                info@shreeverevents.com
                </a>
              </p>
            </div>
          </div>

          <div className="map-section">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28018.562087066042!2d77.33659942663694!3d28.620162115292676!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5456ef36d9f%3A0x3b7191b1286136c8!2sSector%2062%2C%20Noida%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1747042668251!5m2!1sen!2sin"
              title="map"
              width="100%"
              height="100%"
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>

      <Place />
      <Talk />
    </>
  );
};

export default ContactUs;
